/**
 * Centralized Bearer-token header helper.
 *
 * The app stores a JWT in localStorage under 'auth_token' (see services/api.ts).
 * Cookies also carry the session when `credentials: 'include'` is set, but the
 * backend prefers the Authorization header. Using this helper in both the push
 * subscription flow and the offline queue keeps auth behaviour consistent and
 * avoids silent 401s when cookies aren't present (e.g. after a browser restart
 * on a subdomain).
 */

const AUTH_TOKEN_KEY = 'auth_token';

export const withAuthHeader = (headers: Record<string, string> = {}): Record<string, string> => {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem(AUTH_TOKEN_KEY) : null;
    if (token) {
      return { ...headers, Authorization: `Bearer ${token}` };
    }
  } catch {
    // localStorage access blocked (e.g. Safari private mode) — cookies still cover us.
  }
  return headers;
};

export const jsonAuthHeaders = (): Record<string, string> =>
  withAuthHeader({ 'Content-Type': 'application/json' });
